import {
  ATTRIBUTION_PARAMS,
  type AttributionParam,
  type StoredAttribution,
  type TouchData,
} from './constants';

export const parseAttributionFromSearch = (
  search: string,
): Partial<Record<AttributionParam, string>> => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const result: Partial<Record<AttributionParam, string>> = {};

  ATTRIBUTION_PARAMS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      result[key] = value;
    }
  });

  return result;
};

export const hasAttributedParams = (
  params: Partial<Record<AttributionParam, string>>,
): boolean => Object.keys(params).length > 0;

export const mergeAttributionVisit = (
  stored: StoredAttribution,
  attributionParams: Partial<Record<AttributionParam, string>>,
  landingUrl: string,
  referrer: string,
  timestamp: number,
): StoredAttribution => {
  if (!hasAttributedParams(attributionParams)) {
    return stored;
  }

  const touch: TouchData = {
    ...attributionParams,
    landing_url: landingUrl,
    referrer,
    timestamp,
  };

  const next: StoredAttribution = {
    ...stored,
    last_touch: touch,
    last_landing_url: landingUrl,
    last_referrer: referrer,
  };

  if (!stored.first_touch) {
    next.first_touch = touch;
    next.first_landing_url = landingUrl;
    next.first_referrer = referrer;
  }

  return next;
};

export const appendAttributionToUrl = (targetUrl: string, search: string): string => {
  const attribution = parseAttributionFromSearch(search);
  if (!hasAttributedParams(attribution)) {
    return targetUrl;
  }

  const url = new URL(targetUrl);
  Object.entries(attribution).forEach(([key, value]) => {
    if (value) {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
};
